import { createAction } from 'redux-actions'
import {
  ADD_PROPERTY_NAME,
  ADD_PROPERTY_NAME_FAILED,
  ADD_PROPERTY_NAME_SUCCEEDED,
  CLEAR_CREATED_PROPERTY_NAME,
  DELETE_PROPERTY_NAME,
  DELETE_PROPERTY_NAME_FAILED,
  DELETE_PROPERTY_NAME_SUCCEEDED,
  GET_PROPERTY_NAMES,
  GET_PROPERTY_NAMES_FAILED,
  GET_PROPERTY_NAMES_SUCCEEDED,
} from 'Redux/Types/PropertyNameTypes'

export const deletePropertyName = createAction(DELETE_PROPERTY_NAME)
export const deletePropertyNameFailed = createAction(DELETE_PROPERTY_NAME_FAILED)
export const deletePropertyNameSucceeded = createAction(DELETE_PROPERTY_NAME_SUCCEEDED)

export const getPropertyNames = createAction(GET_PROPERTY_NAMES)
export const getPropertyNamesFailed = createAction(GET_PROPERTY_NAMES_FAILED)
export const getPropertyNamesSucceeded = createAction(GET_PROPERTY_NAMES_SUCCEEDED)

export const addPropertyName = createAction(ADD_PROPERTY_NAME)
export const addPropertyNameFailed = createAction(ADD_PROPERTY_NAME_FAILED)
export const addPropertyNameSucceeded = createAction(ADD_PROPERTY_NAME_SUCCEEDED)
export const clearCreatedPropertyName = createAction(CLEAR_CREATED_PROPERTY_NAME)
